/* eslint-disable */
export default {
  to: '撥給：',
  enterNameOrPhoneNumber: '輸入號碼',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"enterNameOrPhoneNumber"@#@ @source: @#@"Enter Number"@#@
